var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
  pluginRegistry.registerDeploymentAction("Octopus.Script", function() {
    return {
      executionLocation: actionExecutionLocations.targetOrServer,
      canChooseRoles: true,
      canHaveChildren: function(step)
      {
        return (typeof step.Properties['Octopus.Action.TargetRoles'] !== 'undefined');
      },
      canBeChild: true,
      hasPackages: function(action)
      {
        if (action.Properties && action.Properties['Octopus.Action.Script.ScriptSource'] === 'Package')
        {
          return true;
        }
        return false;
      },
      summaryTemplateUrl: "areas/projects/actions/Octopus.Script_summary.html",
      editTemplateUrl: "areas/projects/actions/Octopus.Script_edit.html",
      preLink: function(scope) {
        scope.editorLoaded = function(editor) {
          scope.scriptEditor = editor;
        };
      },
      editLink: function(scope) {
        scope.$watch('action.Properties', function(nv) {
          if (nv != null) {
            if (nv['Octopus.Action.Script.ScriptSource']) {
              var isRunFromPackage = nv['Octopus.Action.Script.ScriptSource'] === 'Package';
              if(isRunFromPackage) {
                nv['Octopus.Action.Script.Syntax'] = null;
                nv['Octopus.Action.Script.ScriptBody'] = null;
              } else {
                if(!nv['Octopus.Action.Script.Syntax']) {
                  nv['Octopus.Action.Script.Syntax'] = "PowerShell";
                }
                nv['Octopus.Action.Script.ScriptFileName'] = null;
                nv['Octopus.Action.Package.FeedId'] = null;
                nv['Octopus.Action.Package.PackageId'] = null;
              }

              var canRunBeforeAcquisition = !isRunFromPackage;
              if (scope.viewOptions) {
                scope.viewOptions.canRunBeforeAcquisition = canRunBeforeAcquisition;
              }
              
              if (scope.step.RequiresPackagesToBeAcquired === undefined) {
                scope.step.RequiresPackagesToBeAcquired = canRunBeforeAcquisition ? 'false' : 'true';
              }
            }

            if (scope.action.Properties && scope.action.Properties['Octopus.Action.RunOnServer'] && scope.action.Properties['Octopus.Action.RunOnServer'] === 'true') {
                scope.syntaxFilter = "'PowerShell, CSharp, FSharp'";
            } else {
                scope.syntaxFilter = "'PowerShell, CSharp, Bash, FSharp'";
            }

          }
        }, true);

        if (scope.action &&
            scope.action.Properties &&
            scope.action.Properties['Octopus.Action.Script.Syntax'] &&
            scope.action.Properties['Octopus.Action.Script.ScriptSource'] &&
            scope.action.Properties['Octopus.Action.RunOnServer']) {
            return;
        }

        var unwatch = scope.$watch('action.Properties', function (nv) {
            if (nv != null) {
                if (!nv['Octopus.Action.Script.Syntax']) {
                    nv['Octopus.Action.Script.Syntax'] = "PowerShell";
                }
                if (!nv['Octopus.Action.Script.ScriptSource']) {
                    nv['Octopus.Action.Script.ScriptSource'] = "Inline";
                }
                if (!nv['Octopus.Action.RunOnServer']) {
                    nv['Octopus.Action.RunOnServer'] = 'false';
                }
            }
            unwatch();
        });

      }
    };
  });
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/Octopus.Script.js
// module id = 27471144261390
// module chunks = 1